import { render, staticRenderFns } from "./ClientAuditOverview.vue?vue&type=template&id=d2da8360"
import script from "./ClientAuditOverview.vue?vue&type=script&lang=js"
export * from "./ClientAuditOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports